(function () {
    'use strict';

    const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xykzvkqj';
    const OQ_DEBUG = false;
   
    const lang = document.documentElement.lang || 'en';
    const i18n = {
      en: {
        privacyAck: "I confirm that I have read and agree to the Privacy Policy and consent to the collection and use of my information for the purpose of processing this quote request.",
        privacyPolicy: "Privacy Policy",
        quoteTitle: "Quote Request Confirmation",
        unofficial: "",
        whatHappensNext: "What happens next?",
        note: "Your account representative will contact you within 1–4 business hours (Monday–Friday, 9 AM – 5 PM EST) with pricing, lead times, and availability. Your formal quote will be sent via email—if you have questions or need to modify your request, our team is here to help.",
        disclaimer2: "",
        empty: "No items in your quote list yet.",
        added: "Added to quote.",
        viewQuote: "View your quote",
        alertAddOne: "Please add at least one product.",
        alertFill: "Please fill in all required fields and acknowledge.",
        alertSuccess: "Quote submitted successfully! PDF downloaded and sent to our team.",
        alertError: "Error submitting quote. Please try again.",
        confirmClear: "Are you sure you want to clear your quote list?",
        pdfFail: "Unable to generate PDF in this browser. Please try another browser or contact support.",
        product: "Product",
        variant: "Variant",
        qty: "Qty",
        tableProduct: "Product",
        tableVariant: "Variant",
        tableSku: "SKU",
        tableQty: "Qty",
        btnSavePdf: "Save as PDF",
        btnClear: "Clear quote",
        btnSubmit: "Submit quote",
        reference: "Reference:",
        date: "Date:",
        quoteFile: "Quote",
        requestQuote: "Request Quote",
        requestQuoteTitle: "Request Your Quote",
        nameLabel: "Name",
        companyLabel: "Company",
        emailLabel: "Email",
        phoneLabel: "Phone",
        messageLabel: "Message",
        ackLabel: "I acknowledge that official quotes can only be issued by our team representatives and that this request does not constitute a binding quote",
        placeholderName: "Enter your name",
        placeholderCompany: "Enter your company",
        placeholderEmail: "Enter your email",
        placeholderPhone: "Enter your phone",
        placeholderMessage: "Enter your message",
        customerInfo: "Customer Information:",
        footer_contact_title: "Contact Information:",
        footer_sales: "Sales",
        footer_inquiry: "General Inquiry",
        footer_support: "Technical Support",
        footer_na: "North America:",
        footer_latam: "Latin America:",
        footer_eu: "Europe:",
        footer_email_general: "<info@optic.ca>",
        footer_phone_na: "+1.514.447.8100",
        footer_phone_latam: "Toll Free +1.888.978.6470",
        footer_disclaimer: "We look forward to serving you.",
        subtotal: "Subtotal",
        differentProducts: "different products",
        differentSkus: "different SKUs",
        units: "units",
        differentProductsLabel: "{count}x Different Products",
        totalProductQuantityLabel: "{count}x Total Product Quantity",
        alertInvalidEmail: "Please enter a valid email address.",
        alertInvalidPhone: "Please enter a valid phone number.",
        alertRateLimit: "Please wait a moment before submitting again."
      },
      fr: {
        privacyAck: "Je confirme avoir lu et accepté la Politique de confidentialité et consens à la collecte et à l'utilisation de mes informations dans le but de traiter cette demande de soumission.",
        privacyPolicy: "Politique de confidentialité",
        quoteTitle: "Confirmation de demande de soumission",
        unofficial: "",
        whatHappensNext: "Quelle est la prochaine étape?",
        note: "Votre représentant vous contactera dans un délai de 1 à 4 heures ouvrables (du lundi au vendredi, de 9 h à 17 h HNE) avec les prix, les délais et la disponibilité. Votre soumission officielle vous sera envoyée par courriel. Si vous avez des questions ou souhaitez modifier votre demande, notre équipe est là pour vous aider.",
        disclaimer2: "",
        empty: "Aucun article dans votre liste de soumission.",
        added: "Ajouté à la soumission.",
        viewQuote: "Voir votre soumission",
        alertAddOne: "Veuillez ajouter au moins un produit.",
        alertFill: "Veuillez remplir tous les champs obligatoires et accepter.",
        alertSuccess: "Soumission envoyée avec succès ! PDF téléchargé et envoyé à notre équipe.",
        alertError: "Erreur lors de l'envoi de la soumission. Veuillez réessayer.",
        confirmClear: "Êtes-vous sûr de vouloir effacer votre liste de soumission ?",
        pdfFail: "Impossible de générer le PDF dans ce navigateur. Essayez un autre navigateur ou contactez le support.",
        product: "Produit",
        variant: "Variante",
        qty: "Qté",
        tableProduct: "Produit",
        tableVariant: "Variante",
        tableSku: "UGS (SKU)",
        tableQty: "Qté",
        btnSavePdf: "Télécharger le PDF",
        btnClear: "Effacer la soumission",
        btnSubmit: "Envoyer la soumission",
        reference: "Référence :",
        date: "Date :",
        quoteFile: "Soumission",
        requestQuote: "Demander une soumission",
        requestQuoteTitle: "Demander votre soumission",
        nameLabel: "Nom",
        companyLabel: "Entreprise",
        emailLabel: "Courriel",
        phoneLabel: "Téléphone",
        messageLabel: "Message",
        ackLabel: "Je reconnais que les soumissions officielles ne peuvent être émises que par les représentants de notre équipe et que cette demande ne constitue pas une soumission contraignante",
        placeholderName: "Entrez votre nom",
        placeholderCompany: "Entrez votre entreprise",
        placeholderEmail: "Entrez votre Courriel",
        placeholderPhone: "Entrez votre téléphone",
        placeholderMessage: "Entrez votre message",
        customerInfo: "Renseignements sur le client :",
        footer_contact_title: "Coordonnées :",
        footer_sales: "Ventes",
        footer_inquiry: "Renseignements généraux",
        footer_support: "Soutien technique",
        footer_na: "Amérique du Nord :",
        footer_latam: "Amérique latine :",
        footer_eu: "Europe :",
        footer_email_general: "<info@optic.ca>",
        footer_phone_na: "+1.514.447.8100",
        footer_phone_latam: "Sans frais +1.888.978.6470",
        footer_disclaimer: "Nous avons hâte de vous servir.",
        subtotal: "Sous-total",
        differentProducts: "produits différents",
        differentSkus: "UGS différentes",
        units: "unités",
        differentProductsLabel: "{count}x Produits différents",
        totalProductQuantityLabel: "{count}x Quantité totale de produits",
        alertInvalidEmail: "Veuillez entrer une adresse courriel valide.",
        alertInvalidPhone: "Veuillez entrer un numéro de téléphone valide.",
        alertRateLimit: "Veuillez patienter avant de soumettre à nouveau."
      },
      es: {
        privacyAck: "Confirmo que he leído y acepto la Política de privacidad y consiento la recopilación y el uso de mi información con el propósito de procesar esta solicitud de cotización.",
        privacyPolicy: "Política de privacidad",
        quoteTitle: "Confirmación de solicitud de cotización",
        unofficial: "",
        whatHappensNext: "¿Qué sucede después?",
        note: "Su representante de cuenta se comunicará con usted dentro de 1 a 4 horas hábiles (lunes a viernes, 9 AM – 5 PM EST) con precios, tiempos de entrega y disponibilidad. Su cotización formal se enviará por correo electrónico. Si tiene preguntas o necesita modificar su solicitud, nuestro equipo está aquí para ayudarle.",
        disclaimer2: "",
        empty: "No hay artículos en su lista de cotización.",
        added: "Añadido a la cotización.",
        viewQuote: "Ver su cotización",
        alertAddOne: "Por favor agregue al menos un producto.",
        alertFill: "Por favor complete todos los campos requeridos y acepte.",
        alertSuccess: "Cotización enviada con éxito! PDF descargado y enviado a nuestro equipo.",
        alertError: "Error al enviar la cotización. Por favor intente de nuevo.",
        confirmClear: "¿Está seguro de que quiere borrar su lista de cotización?",
        pdfFail: "No se puede generar PDF en este navegador. Pruebe otro navegador o contacte soporte.",
        product: "Producto",
        variant: "Variante",
        qty: "Cant.",
        tableProduct: "Producto",
        tableVariant: "Variante",
        tableSku: "SKU (Referencia)",
        tableQty: "Cant.",
        btnSavePdf: "Descargar PDF",
        btnClear: "Borrar cotización",
        btnSubmit: "Enviar cotización",
        reference: "Referencia:",
        date: "Fecha:",
        quoteFile: "Cotización",
        requestQuote: "Solicitar cotización",
        requestQuoteTitle: "Solicitar su cotización",
        nameLabel: "Nombre",
        companyLabel: "Empresa",
        emailLabel: "Correo electrónico",
        phoneLabel: "Teléfono",
        messageLabel: "Mensaje",
        ackLabel: "Reconozco que las cotizaciones oficiales solo pueden ser emitidas por los representantes de nuestro equipo y que esta solicitud no constituye una cotización vinculante",
        placeholderName: "Introduzca su nombre",
        placeholderCompany: "Introduzca su empresa",
        placeholderEmail: "Introduzca su correo electrónico",
        placeholderPhone: "Introduzca su teléfono",
        placeholderMessage: "Introduzca su mensaje",
        customerInfo: "Información del cliente :",
        footer_contact_title: "Información de contacto :",
        footer_sales: "Ventas",
        footer_inquiry: "Consulta general",
        footer_support: "Soporte técnico",
        footer_na: "Norteamérica:",
        footer_latam: "América Latina:",
        footer_eu: "Europa:",
        footer_email_general: "<info@optic.ca>",
        footer_phone_na: "+1.514.447.8100",
        footer_phone_latam: "Línea gratuita +1.888.978.6470",
        footer_disclaimer: "Esperamos poder servirle.",
        subtotal: "Subtotal",
        differentProducts: "productos diferentes",
        differentSkus: "SKU diferentes",
        units: "unidades",
        differentProductsLabel: "{count}x Productos diferentes",
        totalProductQuantityLabel: "{count}x Cantidad total de productos",
        alertInvalidEmail: "Por favor ingrese un correo electrónico válido.",
        alertInvalidPhone: "Por favor ingrese un número de teléfono válido.",
        alertRateLimit: "Por favor espere un momento antes de enviar de nuevo."
      }
    };
   
    const t = i18n[lang] || i18n.en;
    const logoUrl = 'https://cdn.shopify.com/s/files/1/0618/5559/6738/files/A1_OPTICLOGO_COLOR_2STORY_FULL.png?v=1758296764';
    const DEFAULT_MARGIN_TOP = 12;
    const DEFAULT_MARGIN_LR = 12.75;
   
    // [SEC-005] Rate limiting: 30s
    const RATE_LIMIT_MS = 30000;
    const RATE_LIMIT_KEY = 'oq_last_submit';
   
    // [SEC-008] Fallback thumbnail
    const PLACEHOLDER_THUMBNAIL = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSIjZjBmMGYwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTQiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIiBmaWxsPSIjY2NjIj5QPC90ZXh0Pjwvc3ZnPg==';
   
    let oqQuoteBuilder = [];
   
    // [SEC-007] Logging
    function oqLog(...args) {
      if (OQ_DEBUG) {
        console.log('[QuoteMVP]', ...args);
      }
    }
   
    // [SEC-003] Validation & Sanitization
    function validateEmail(email) {
      if (!email) return false;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email.trim());
    }
   
    function validatePhone(phone) {
      if (!phone || phone.trim() === '') return true;
      const phoneRegex = /^[\d\s\-\+\(\)\.]{7,25}$/;
      return phoneRegex.test(phone.trim());
    }
   
    // [SEC-009] Clean input to prevent XSS/Injection
    function sanitizeInput(str, maxLen = 500) {
      if (!str && str !== 0) return '';
      return String(str)
        .trim()
        .substring(0, maxLen)
        .replace(/[<>]/g, '');
    }
   
    // [SEC-005] Rate Limiting
    function canSubmit() {
      try {
        const lastSubmit = localStorage.getItem(RATE_LIMIT_KEY);
        if (!lastSubmit) return true;
        const elapsed = Date.now() - parseInt(lastSubmit, 10);
        return elapsed > RATE_LIMIT_MS;
      } catch (e) {
        return true;
      }
    }
   
    function recordSubmission() {
      try {
        localStorage.setItem(RATE_LIMIT_KEY, Date.now().toString());
      } catch (e) {
        oqLog('Failed to record submission time', e);
      }
    }
   
    function escapeHtml(str) {
      if (!str && str !== 0) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }
   
    // Load Saved Quote
    (function loadSaved() {
      try {
        const saved = localStorage.getItem('oqQuoteBuilder');
        if (saved) {
          oqQuoteBuilder = JSON.parse(saved) || [];
          oqQuoteBuilder.forEach(item => {
            if (!item.thumbnail || item.thumbnail === '' || item.thumbnail.includes('[placeholder.com](http://placeholder.com)')) {
              item.thumbnail = PLACEHOLDER_THUMBNAIL;
            }
          });
          oqSaveQuote();
        }
      } catch (e) {
        oqLog('Failed to load saved quote', e);
        oqQuoteBuilder = [];
      }
    })();
   
    function oqSaveQuote() {
      try {
        localStorage.setItem('oqQuoteBuilder', JSON.stringify(oqQuoteBuilder));
      } catch (e) {
        oqLog('Failed to save quote', e);
      }
    }
   
    function oqGenerateRefCode() {
      // Generate consistent reference based on quote items
      // Same items = same reference, different items = new reference
      try {
        const itemsHash = JSON.stringify(oqQuoteBuilder.map(i => i.variantId + ':' + i.quantity).sort()).split('').reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0).toString(36).toUpperCase();
        const stored = localStorage.getItem('oqRefData');
        if (stored) {
          const { hash, ref } = JSON.parse(stored);
          if (hash === itemsHash && ref) return ref;
        }
        const newRef = Math.random().toString(36).substring(2, 8).toUpperCase();
        localStorage.setItem('oqRefData', JSON.stringify({ hash: itemsHash, ref: newRef }));
        return newRef;
      } catch (e) {
        return Math.random().toString(36).substring(2, 8).toUpperCase();
      }
    }
   
    function oqAddItem(productTitle, variantInfo, qty = 1, thumbnail = '') {
      const variantId =
        (variantInfo && variantInfo.id)
          ? String(variantInfo.id)
          : "no-variant-" + btoa(productTitle).substring(0, 12);
   
      let variantName =
        (variantInfo && variantInfo.title && variantInfo.title.trim())
          ? variantInfo.title.trim()
          : "N/A";
   
      if (variantName === productTitle) {
        variantName = "N/A";
      }
   
      let sku = "N/A";
      const variantsJson = document.getElementById("product-variants-json");
      if (variantsJson) {
        try {
          const variants = JSON.parse(variantsJson.textContent);
          const matched = variants.find(function (v) {
            return String(v.id) === variantId;
          });
          if (matched && matched.sku) {
            sku = matched.sku;
          }
        } catch (e) {
          oqLog("Failed to parse variants for SKU", e);
        }
      }
   
      const safeThumbnail = thumbnail || PLACEHOLDER_THUMBNAIL;
   
      const existing = oqQuoteBuilder.find(it => it.productTitle === productTitle && it.variantId === variantId);
      if (existing) {
        existing.quantity += Number(qty) || 1;
        existing.sku = sku;
        if (thumbnail) existing.thumbnail = thumbnail;
      } else {
        oqQuoteBuilder.push({
          productTitle: productTitle,
          variantId: variantId,
          variantName: variantName,
          sku: sku,
          quantity: Number(qty) || 1,
          thumbnail: safeThumbnail
        });
      }
      oqSaveQuote();
      oqUpdateQuoteTable();
    }
   
    // Variant Detection
    let oqCurrentVariant = null;
   
    document.addEventListener('variant:change', (e) => {
      if (e.detail && e.detail.variant) {
        oqCurrentVariant = {
          id: String(e.detail.variant.id),
          title: e.detail.variant.title || 'Default'
        };
      }
    });
   
    function updateCurrentVariant() {
      let current = { id: null, title: 'Default' };
      const selector = document.querySelector('[name="id"]');
      if (selector) {
        const opt = selector.options[selector.selectedIndex];
        current = { id: opt?.value, title: opt?.textContent?.trim() || 'Default' };
      } else {
        const product = window.meta?.product;
        if (product) {
          const variantParam = new URLSearchParams(window.location.search).get('variant');
          const found = product.variants?.find(v => String(v.id) === variantParam) || product.variants?.[0];
          if (found) current = { id: found.id, title: found.title || 'Default' };
        }
      }
      oqCurrentVariant = current;
    }
   
    updateCurrentVariant();
   
    function getSelectedVariant() {
      if (oqCurrentVariant && oqCurrentVariant.id) {
        return oqCurrentVariant;
      }
      const selector = document.querySelector('[name="id"]');
      if (selector) {
        const opt = selector.options[selector.selectedIndex];
        return {
          id: String(opt?.value),
          title: opt?.textContent?.trim() || 'Default'
        };
      }
      return { id: "no-variant", title: "Default" };
    }
   
    function getCurrentLangPrefix() {
      const path = window.location.pathname;
      const firstSegment = path.split('/')[1];
      if (['fr', 'es'].includes(firstSegment)) return `/${firstSegment}`;
      return '';
    }
   
    // Feedback Toast
    function showQuoteFeedback(itemData) {
      const current = getCurrentLangPrefix().replace('/', '') || Shopify?.locale || 'en';
      const t = i18n?.[current] || i18n?.en || { viewQuote: 'View Quote', added: 'Added' };
   
      document.querySelectorAll('.oq-premium-toast').forEach(t => t.remove());
   
      const thumb = itemData.thumbnail?.trim() || PLACEHOLDER_THUMBNAIL;
   
      let meta = '';
      if (itemData.variantTitle && itemData.variantTitle !== 'Default' && itemData.variantTitle !== itemData.title) {
        meta += itemData.variantTitle;
      }
      if (itemData.quantity > 1) {
        meta += (meta ? ' • ' : '') + `Qty: ${itemData.quantity}`;
      }
   
      const langPrefix = getCurrentLangPrefix();
      const viewUrl = `${langPrefix}/pages/quote`;
   
      const toast = document.createElement('div');
      toast.className = 'oq-premium-toast';
      toast.innerHTML = `
        <img src="${escapeHtml(thumb)}" alt="${escapeHtml(itemData.title || 'Product')}"
             onerror="this.src='${PLACEHOLDER_THUMBNAIL}';">
        <div class="oq-toast-content">
          <div class="oq-toast-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 L9 17 L4 12"></path></svg>
            <span>${escapeHtml(t.added)}</span>
          </div>
          <div class="oq-toast-product">${escapeHtml(itemData.title || 'Product')}</div>
          ${meta ? `<div class="oq-toast-meta">${escapeHtml(meta)}</div>` : ''}
          <a href="${escapeHtml(viewUrl)}" class="oq-view-quote-btn">${escapeHtml(t.viewQuote)} →</a>
        </div>
      `;
      document.body.appendChild(toast);
   
      const bubble = document.getElementById('quote-bubble');
      if (bubble && window.innerWidth > 768) {
        const bubbleRect = bubble.getBoundingClientRect();
        const gap = 16;
        const neededBottom = window.innerHeight - bubbleRect.top + gap;
        toast.style.bottom = `${Math.max(90, neededBottom)}px`;
      }
   
      requestAnimationFrame(() => toast.style.opacity = '1');
   
      const hide = () => {
        toast.classList.add('removing');
        toast.addEventListener('animationend', () => toast.remove(), { once: true });
      };
   
      setTimeout(hide, 1800);
      toast.addEventListener('click', hide);
    }
   
    function bindAddToQuoteButtons() {
      document.querySelectorAll('.oq-add-to-quote:not([data-oq-bound])').forEach(button => {
        button.dataset.oqBound = 'true';
        button.addEventListener('click', (ev) => {
          ev.preventDefault();
          updateCurrentVariant();
          const container = button.closest('.oq-quote-builder');
          const productTitle = container?.dataset.productTitle || 'Product';
          const qtyInput = container?.querySelector('input[type="number"]');
          const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
          const variant = getSelectedVariant();
          if (!variant.id) return alert('Select a variant.');
   
          const thumb = container.querySelector('img')?.src ||
                        document.querySelector('meta[property="og:image"]')?.content ||
                        document.querySelector('[data-main-image] img')?.src ||
                        document.querySelector('img')?.src || PLACEHOLDER_THUMBNAIL;
   
          oqAddItem(productTitle, variant, qty, thumb);
          updateQuoteBubblePreview(oqQuoteBuilder);
   
          showQuoteFeedback({
            title: productTitle,
            variantTitle: variant.title || 'Default',
            quantity: qty,
            thumbnail: thumb
          });
        });
      });
    }
   
    // Quote Table
    function oqUpdateQuoteTable() {
      const container = document.querySelector('#oq-quote-table');
      if (!container) return;
   
      if (typeof oqUpdateActionButtons !== 'function') {
        window.oqUpdateActionButtons = function () {
          const hasItems = oqQuoteBuilder.length > 0;
          const pdfBtn = document.querySelector('#oq-save-pdf');
          const clearBtn = document.querySelector('#oq-clear-quote');
          if (pdfBtn) pdfBtn.disabled = !hasItems;
          if (clearBtn) clearBtn.disabled = !hasItems;
        };
        updateQuoteBubblePreview(oqQuoteBuilder);
      }
   
      container.innerHTML = '';
      container.style.width = '100%';
      container.style.overflowX = 'auto';
      container.style.maxWidth = '100%';
      container.style.position = 'relative';
   
      const header = document.createElement('div');
      header.className = 'oq-header';
      header.style.display = 'flex';
      header.style.fontWeight = 'bold';
      header.style.borderBottom = '1px solid #ddd';
      header.style.padding = '8px 0';
      header.style.position = 'relative';
   
      const skuHeader = document.createElement('div');
      skuHeader.style.flex = '1';
      skuHeader.style.padding = '0 16px 0 8px';
      skuHeader.style.wordBreak = 'break-word';
      skuHeader.textContent = t.tableSku;
      header.appendChild(skuHeader);
   
      const prodHeader = document.createElement('div');
      prodHeader.style.flex = '2.8';
      prodHeader.style.padding = '0 16px';
      prodHeader.style.wordBreak = 'break-word';
      prodHeader.textContent = t.tableProduct;
      header.appendChild(prodHeader);
   
      const qtyHeader = document.createElement('div');
      qtyHeader.style.flex = '1';
      qtyHeader.style.padding = '0 16px 0 8px';
      qtyHeader.style.textAlign = 'right';
      qtyHeader.textContent = t.tableQty;
      header.appendChild(qtyHeader);
   
      container.appendChild(header);
   
      if (!oqQuoteBuilder.length) {
        const emptyDiv = document.createElement('div');
        emptyDiv.style.textAlign = 'center';
        emptyDiv.style.padding = '8px';
        emptyDiv.textContent = t.empty;
        container.appendChild(emptyDiv);
        oqUpdateActionButtons();
        return;
      }
   
      oqQuoteBuilder.forEach((item, index) => {
        if (!item.quantity || item.quantity < 1) item.quantity = 1;
   
        const row = document.createElement('div');
        row.className = 'oq-row';
        row.style.display = 'flex';
        row.style.alignItems = 'center';
        row.style.borderBottom = '1px solid #ddd';
        row.style.padding = '8px 0';
        row.style.position = 'relative';
   
        if (index % 2 === 1) row.style.backgroundColor = '#f9f9f9';
   
        const skuCell = document.createElement('div');
        skuCell.style.flex = '1';
        skuCell.style.padding = '0 16px 0 8px';
        skuCell.style.wordBreak = 'break-word';
        skuCell.textContent = item.sku || 'N/A';
        row.appendChild(skuCell);
   
        const prodCell = document.createElement('div');
        prodCell.style.flex = '2.8';
        prodCell.style.padding = '0 16px';
        prodCell.style.wordBreak = 'break-word';
        prodCell.textContent = item.productTitle || 'Unknown';
        row.appendChild(prodCell);
   
        const qtyCell = document.createElement('div');
        qtyCell.style.flex = '1';
        qtyCell.style.padding = '0 16px 0 8px';
        qtyCell.style.display = 'flex';
        qtyCell.style.justifyContent = 'flex-end';
        qtyCell.style.alignItems = 'center';
        qtyCell.style.gap = '8px';
        qtyCell.dataset.index = index;
   
        const qtySpan = document.createElement('span');
        qtySpan.className = 'oq-qty-text';
        qtySpan.textContent = item.quantity;
        qtyCell.appendChild(qtySpan);
   
        const editBtn = document.createElement('button');
        editBtn.className = 'button button--secondary oq-edit-item';
        editBtn.dataset.index = index;
        editBtn.textContent = 'Edit';
        qtyCell.appendChild(editBtn);
   
        const removeBtn = document.createElement('button');
        removeBtn.className = 'button button--secondary oq-remove-item';
        removeBtn.dataset.index = index;
        removeBtn.textContent = '×';
        qtyCell.appendChild(removeBtn);
   
        row.appendChild(qtyCell);
        container.appendChild(row);
      });
   
      const distinctProducts = oqQuoteBuilder.length;
      const distinctSKUs = new Set(oqQuoteBuilder.map(it => it.sku)).size;
      const totalQty = oqQuoteBuilder.reduce((sum, it) => sum + (Number(it.quantity) || 0), 0);
   
      if (distinctProducts >= 2) {
        const subtotalRow = document.createElement('div');
        subtotalRow.className = 'oq-subtotal-row';
        subtotalRow.style.display = 'flex';
        subtotalRow.style.alignItems = 'center';
        subtotalRow.style.borderTop = '1px solid #ddd';
        subtotalRow.style.padding = '8px 0';
        subtotalRow.style.position = 'relative';
        subtotalRow.style.fontWeight = 'bold';
   
        const skuSubtotal = document.createElement('div');
        skuSubtotal.style.flex = '1';
        skuSubtotal.style.padding = '0 16px 0 8px';
        skuSubtotal.textContent = `${distinctSKUs} ${t.differentSkus}`;
        subtotalRow.appendChild(skuSubtotal);
   
        const prodSubtotal = document.createElement('div');
        prodSubtotal.style.flex = '2.8';
        prodSubtotal.style.padding = '0 16px';
        prodSubtotal.textContent = `${t.subtotal}: ${distinctProducts} ${t.differentProducts}`;
        subtotalRow.appendChild(prodSubtotal);
   
        const qtySubtotal = document.createElement('div');
        qtySubtotal.style.flex = '1';
        qtySubtotal.style.padding = '0 16px 0 8px';
        qtySubtotal.style.textAlign = 'right';
        qtySubtotal.textContent = `${totalQty} ${t.units}`;
        subtotalRow.appendChild(qtySubtotal);
   
        container.appendChild(subtotalRow);
      }
   
      document.querySelectorAll('.oq-edit-item').forEach(btn => {
        btn.addEventListener('click', () => {
          const index = parseInt(btn.dataset.index, 10);
          const qtyCell = btn.parentNode;
          const qtySpan = qtyCell.querySelector('.oq-qty-text');
   
          if (qtyCell.querySelector('input')) return;
   
          const input = document.createElement('input');
          input.type = 'number';
          input.min = '1';
          input.value = oqQuoteBuilder[index].quantity;
          input.style.width = '60px';
          input.style.padding = '4px';
          input.style.border = '1px solid #ddd';
          input.style.borderRadius = '4px';
         
          // [FIX] Add saving lock
          let isSaving = false;
   
          qtyCell.replaceChild(input, qtySpan);
          input.focus();
          input.select();
   
          function saveQty() {
            // [FIX] Prevent double-firing or operating on detached nodes
            if (isSaving) return;
            if (!qtyCell.contains(input)) return;
           
            isSaving = true; // Lock
   
            let newQty = parseInt(input.value, 10);
            if (isNaN(newQty) || newQty < 1) newQty = 1;
   
            oqQuoteBuilder[index].quantity = newQty;
            oqSaveQuote();
   
            const newSpan = document.createElement('span');
            newSpan.className = 'oq-qty-text';
            newSpan.textContent = newQty;
   
            // [FIX] Wrap replaceChild in try-catch
            try {
                qtyCell.replaceChild(newSpan, input);
            } catch (err) {
                // Ignore if node is missing (race condition)
            }
            oqUpdateQuoteTable();
          }
   
          input.addEventListener('keypress', e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              saveQty();
            }
          });
   
          input.addEventListener('blur', saveQty);
        });
      });
   
      document.querySelectorAll('.oq-remove-item').forEach(btn => {
        btn.addEventListener('click', () => {
          const index = parseInt(btn.dataset.index, 10);
          if (!isNaN(index) && index >= 0 && index < oqQuoteBuilder.length) {
            oqQuoteBuilder.splice(index, 1);
            oqSaveQuote();
            oqUpdateQuoteTable();
            updateQuoteBubblePreview(oqQuoteBuilder);
          }
        });
      });
   
      oqUpdateActionButtons();
    }
   
    function oqSaveOpenQtys() {
      document.querySelectorAll('#oq-quote-table input[type="number"]').forEach(input => {
        const qtyCell = input.parentElement;
        const index = parseInt(qtyCell.dataset.index, 10);
        if (isNaN(index)) return;
        let newQty = parseInt(input.value, 10);
        if (isNaN(newQty) || newQty < 1) newQty = 1;
        oqQuoteBuilder[index].quantity = newQty;
        oqSaveQuote();
        const newSpan = document.createElement('span');
        newSpan.className = 'oq-qty-text';
        newSpan.textContent = newQty;
        qtyCell.replaceChild(newSpan, input);
      });
    }
   
    function oqForceSyncBeforeActions() {
      oqSaveOpenQtys();
      oqUpdateQuoteTable();
      oqSaveQuote();
      updateQuoteBubblePreview(oqQuoteBuilder);
    }
   
    // Popup Modal
    function showQuotePopup() {
      if (oqQuoteBuilder.length === 0) return alert(t.alertAddOne);
      if (document.querySelector('#oq-quote-overlay')) return;
   
      const overlay = document.createElement('div');
      overlay.id = 'oq-quote-overlay';
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundColor = 'rgba(0,0,0,0.5)';
      overlay.style.display = 'flex';
      overlay.style.justifyContent = 'center';
      overlay.style.alignItems = 'center';
      overlay.style.zIndex = '9999';
   
      const modal = document.createElement('div');
      modal.style.backgroundColor = '#fff';
      modal.style.padding = '24px';
      modal.style.borderRadius = '8px';
      modal.style.maxWidth = '500px';
      modal.style.width = '90%';
      modal.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
      modal.style.position = 'relative';
      modal.style.display = 'flex';
      modal.style.flexDirection = 'column';
      modal.style.gap = '16px';
      modal.style.maxHeight = '90vh';
      modal.style.overflowY = 'auto';
      const closeBtn = document.createElement('button');
      closeBtn.textContent = '×';
      closeBtn.style.position = 'absolute';
      closeBtn.style.top = '12px';
      closeBtn.style.right = '12px';
      closeBtn.style.background = 'none';
      closeBtn.style.border = 'none';
      closeBtn.style.fontSize = '24px';
      closeBtn.style.cursor = 'pointer';
      closeBtn.style.color = '#666';
      closeBtn.addEventListener('click', () => overlay.remove());
   
      const title = document.createElement('h3');
      title.textContent = t.requestQuoteTitle;
      title.style.margin = '0';
      title.style.fontSize = '20px';
      title.style.textAlign = 'center';
      title.style.color = '#333';
      title.style.fontWeight = '600';
   
      // Form Fields
      const nameGroup = document.createElement('div');
      nameGroup.className = 'form-group';
      nameGroup.style.display = 'flex';
      nameGroup.style.flexDirection = 'column';
      nameGroup.style.gap = '4px';
      const nameLabel = document.createElement('label');
      nameLabel.innerHTML = `${t.nameLabel} <span style="color:red;">*</span>`;
      nameLabel.style.fontSize = '14px';
      nameLabel.style.fontWeight = '600';
      const nameInput = document.createElement('input');
      nameInput.id = 'oq-quote-name';
      nameInput.type = 'text';
      nameInput.autocomplete = 'name';
      nameInput.placeholder = t.placeholderName;
      nameInput.maxLength = 100;
      nameInput.style.padding = '10px';
      nameInput.style.border = '1px solid #ddd';
      nameInput.style.borderRadius = '4px';
      nameLabel.htmlFor = nameInput.id;
      nameGroup.append(nameLabel, nameInput);
   
      const companyGroup = document.createElement('div');
      companyGroup.className = 'form-group';
      companyGroup.style.display = 'flex';
      companyGroup.style.flexDirection = 'column';
      companyGroup.style.gap = '4px';
      const companyLabel = document.createElement('label');
      companyLabel.innerHTML = `${t.companyLabel} <span style="color:red;">*</span>`;
      companyLabel.style.fontSize = '14px';
      companyLabel.style.fontWeight = '600';
      const companyInput = document.createElement('input');
      companyInput.id = 'oq-quote-company';
      companyInput.type = 'text';
      companyInput.autocomplete = 'organization';
      companyInput.placeholder = t.placeholderCompany;
      companyInput.maxLength = 150;
      companyInput.style.padding = '10px';
      companyInput.style.border = '1px solid #ddd';
      companyInput.style.borderRadius = '4px';
      companyLabel.htmlFor = companyInput.id;
      companyGroup.append(companyLabel, companyInput);
   
      const emailGroup = document.createElement('div');
      emailGroup.className = 'form-group';
      emailGroup.style.display = 'flex';
      emailGroup.style.flexDirection = 'column';
      emailGroup.style.gap = '4px';
      const emailLabel = document.createElement('label');
      emailLabel.innerHTML = `${t.emailLabel} <span style="color:red;">*</span>`;
      emailLabel.style.fontSize = '14px';
      emailLabel.style.fontWeight = '600';
      const emailInput = document.createElement('input');
      emailInput.id = 'oq-quote-email';
      emailInput.type = 'email';
      emailInput.autocomplete = 'email';
      emailInput.placeholder = t.placeholderEmail;
      emailInput.maxLength = 254;
      emailInput.style.padding = '10px';
      emailInput.style.border = '1px solid #ddd';
      emailInput.style.borderRadius = '4px';
      emailInput.spellcheck = false;
      emailInput.autocapitalize = 'off';
      emailLabel.htmlFor = emailInput.id;
      emailGroup.append(emailLabel, emailInput);
   
      const phoneGroup = document.createElement('div');
      phoneGroup.className = 'form-group';
      phoneGroup.style.display = 'flex';
      phoneGroup.style.flexDirection = 'column';
      phoneGroup.style.gap = '4px';
      const phoneLabel = document.createElement('label');
      phoneLabel.innerHTML = `${t.phoneLabel}`;
      phoneLabel.style.fontSize = '14px';
      phoneLabel.style.fontWeight = '600';
      const phoneInput = document.createElement('input');
      phoneInput.id = 'oq-quote-phone';
      phoneInput.type = 'tel';
      phoneInput.autocomplete = 'tel';
      phoneInput.placeholder = t.placeholderPhone;
      phoneInput.maxLength = 25;
      phoneInput.style.padding = '10px';
      phoneInput.style.border = '1px solid #ddd';
      phoneInput.style.borderRadius = '4px';
      phoneLabel.htmlFor = phoneInput.id;
      phoneGroup.append(phoneLabel, phoneInput);
   
      const messageGroup = document.createElement('div');
      messageGroup.className = 'form-group';
      messageGroup.style.display = 'flex';
      messageGroup.style.flexDirection = 'column';
      messageGroup.style.gap = '4px';
      const messageLabel = document.createElement('label');
      messageLabel.innerHTML = `${t.messageLabel}`;
      messageLabel.style.fontSize = '14px';
      messageLabel.style.fontWeight = '600';
      const messageInput = document.createElement('textarea');
      messageInput.id = 'oq-quote-message';
      messageInput.placeholder = t.placeholderMessage;
      messageInput.maxLength = 2000;
      messageInput.style.padding = '10px';
      messageInput.style.border = '1px solid #ddd';
      messageInput.style.borderRadius = '4px';
      messageInput.style.minHeight = '100px';
      messageLabel.htmlFor = messageInput.id;
      messageGroup.append(messageLabel, messageInput);
   
      const ackGroup = document.createElement('div');
      ackGroup.className = 'ack-group';
      ackGroup.style.display = 'flex';
      ackGroup.style.alignItems = 'flex-start';
      ackGroup.style.gap = '8px';
      const ackInput = document.createElement('input');
      ackInput.id = 'oq-quote-ack';
      ackInput.type = 'checkbox';
      ackInput.style.marginTop = '4px';
      const ackLabel = document.createElement('label');
      ackLabel.htmlFor = ackInput.id;
      ackLabel.innerHTML = `${t.ackLabel} <span style="color:red;">*</span>`;
      ackLabel.style.fontSize = '14px';
      ackLabel.style.fontWeight = '600';
      ackLabel.style.lineHeight = '1.4';
      ackGroup.append(ackInput, ackLabel);
      const privacyGroup = document.createElement('div');
      privacyGroup.className = 'ack-group';
      privacyGroup.style.display = 'flex';
      privacyGroup.style.alignItems = 'flex-start';
      privacyGroup.style.gap = '8px';
      const privacyInput = document.createElement('input');
      privacyInput.id = 'oq-quote-privacy';
      privacyInput.type = 'checkbox';
      privacyInput.style.marginTop = '4px';
      const privacyLabel = document.createElement('label');
      privacyLabel.htmlFor = privacyInput.id;
      privacyLabel.innerHTML = `${t.privacyAck.replace(t.privacyPolicy, `<a href="https://www.optic.ca/policies/privacy-policy" target="_blank" rel="noopener noreferrer">${t.privacyPolicy}</a>`)} <span style="color:red;">*</span>`;
      privacyLabel.style.fontSize = '14px';
      privacyLabel.style.fontWeight = '600';
      privacyLabel.style.lineHeight = '1.4';
      privacyGroup.append(privacyInput, privacyLabel);
   
      const submitBtn = document.createElement('button');
      submitBtn.textContent = t.btnSubmit;
      submitBtn.style.width = '100%';
      submitBtn.style.backgroundColor = '#004080';
      submitBtn.style.color = '#fff';
      submitBtn.style.padding = '12px';
      submitBtn.style.border = 'none';
      submitBtn.style.borderRadius = '4px';
      submitBtn.style.cursor = 'pointer';
      submitBtn.style.fontSize = '16px';
   
      function setSubmitting(isSubmitting) {
        if (isSubmitting) {
          submitBtn.disabled = true;
          submitBtn.dataset.prevText = submitBtn.textContent;
          submitBtn.textContent = 'Sending...';
          submitBtn.style.opacity = '0.7';
          submitBtn.style.cursor = 'default';
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.prevText || t.btnSubmit;
          submitBtn.style.opacity = '1';
          submitBtn.style.cursor = 'pointer';
        }
      }
   
      // Send to Formspree with PDF attachment
      async function sendToFormspree(quoteData, pdfData) {
        oqLog('Sending to Formspree with PDF attachment');
        try {
          const items = quoteData.items.map((it, i) =>
            `${i+1}. ${it.productTitle} | SKU: ${it.sku} | ${it.variantName} | Qty: ${it.quantity}`
          ).join('\n');
          const totalQty = quoteData.items.reduce((sum, it) => sum + (it.quantity || 0), 0);

          // Use FormData to support file attachment
          const formData = new FormData();
          formData.append('_subject', `Quote Request: ${quoteData.reference} - ${quoteData.company}`);
          formData.append('reference', quoteData.reference);
          formData.append('name', sanitizeInput(quoteData.name, 100));
          formData.append('company', sanitizeInput(quoteData.company, 150));
          formData.append('email', sanitizeInput(quoteData.email, 254));
          formData.append('_replyto', sanitizeInput(quoteData.email, 254));
          formData.append('phone', sanitizeInput(quoteData.phone, 25) || 'N/A');
          formData.append('message', sanitizeInput(quoteData.message, 2000) || 'N/A');
          formData.append('acknowledgement', quoteData.acknowledgement ? 'Yes' : 'No');
          formData.append('privacyConsent', quoteData.privacy ? 'Yes' : 'No');
          formData.append('totalItems', String(totalQty));
          formData.append('date', new Date(quoteData.timestamp).toLocaleString());
          formData.append('items', items);

          // Attach PDF if provided
          if (pdfData && pdfData.blob) {
            formData.append('attachment', pdfData.blob, pdfData.filename || 'quote.pdf');
            oqLog('PDF attached:', pdfData.filename);
          }

          const resp = await fetch(FORMSPREE_ENDPOINT, {
            method: 'POST',
            headers: {
              'Accept': 'application/json'
            },
            body: formData
          });
          const info = await resp.json().catch(() => null);
          if (resp.ok) {
            oqLog('✓ Submission successful with PDF');
            return { ok: true };
          } else {
            console.error('Formspree error:', resp.status, info);
            return { ok: false, status: resp.status, info };
          }
        } catch (e) {
          console.error('Network error:', e);
          return { ok: false, error: e.message };
        }
      }
   
      submitBtn.addEventListener('click', async () => {
        // Validate inputs
        if (!canSubmit()) return alert(t.alertRateLimit);
        if (!nameInput.value || !companyInput.value || !emailInput.value || !ackInput.checked || !privacyInput.checked) {
          return alert(t.alertFill);
        }
        if (!validateEmail(emailInput.value)) {
          emailInput.focus();
          return alert(t.alertInvalidEmail);
        }
        if (!validatePhone(phoneInput.value)) {
          phoneInput.focus();
          return alert(t.alertInvalidPhone);
        }
        oqForceSyncBeforeActions();
        const quoteData = {
          name: nameInput.value,
          company: companyInput.value,
          email: emailInput.value,
          phone: phoneInput.value,
          message: messageInput.value,
          acknowledgement: ackInput.checked,
          privacy: privacyInput.checked,
          reference: oqGenerateRefCode(),
          timestamp: new Date().toISOString(),
          items: oqQuoteBuilder.slice()
        };
        setSubmitting(true);
        try {
          // Generate PDF as blob for attachment
          oqLog('Generating PDF for attachment...');
          const pdfData = await oqGeneratePdf(quoteData, { returnBlob: true });

          // Send to Formspree with PDF attached
          oqLog('Sending to Formspree with PDF...');
          const result = await sendToFormspree(quoteData, pdfData);
          if (result.ok) {
            recordSubmission();
            alert(t.alertSuccess);
            overlay.remove();
          } else {
            const errMsg = result.info?.error || result.error || '';
            alert(`${t.alertError}${result.status ? ` (${result.status})` : ''} ${errMsg}`.trim());
          }
        } catch (err) {
          console.error('Submit error:', err);
          alert(t.alertError);
        } finally {
          setSubmitting(false);
        }
      });
   
      modal.append(closeBtn, title, nameGroup, companyGroup, emailGroup, phoneGroup, messageGroup, ackGroup, privacyGroup, submitBtn);
      overlay.append(modal);
      document.body.append(overlay);
    }
   
    function bindActions() {
      document.querySelector('#oq-request-quote-btn')?.addEventListener('click', showQuotePopup);
   
      const pdfBtn = document.querySelector('#oq-save-pdf');
      if (pdfBtn && !pdfBtn.dataset.listenerAdded) {
        pdfBtn.dataset.listenerAdded = 'true';
        pdfBtn.addEventListener('click', async () => {
          if (!oqQuoteBuilder.length) return;
          oqForceSyncBeforeActions();
          const quoteData = { reference: oqGenerateRefCode(), timestamp: new Date().toISOString(), items: oqQuoteBuilder.slice() };
          await oqGeneratePdf(quoteData);
        });
      }
   
      const clearBtn = document.querySelector('#oq-clear-quote');
      if (clearBtn && !clearBtn.dataset.listenerAdded) {
        clearBtn.dataset.listenerAdded = 'true';
        clearBtn.addEventListener('click', () => {
          if (!oqQuoteBuilder.length || !confirm(t.confirmClear)) return;
          oqQuoteBuilder = [];
          oqSaveQuote();
          oqUpdateQuoteTable();
          updateQuoteBubblePreview(oqQuoteBuilder);
        });
      }
    }
   
    // PDF Generation
    async function getBase64ImageFromUrl(url) {
      try {
        const res = await fetch(url, { mode: 'cors' });
        const blob = await res.blob();
        return new Promise((resolve) => {
          const img = new Image();
          const objectUrl = URL.createObjectURL(blob);
          img.onload = () => {
            // Resize to max 800px width for crisp logo on 4K screens
            const maxWidth = 800;
            const scale = Math.min(1, maxWidth / img.width);
            const width = img.width * scale;
            const height = img.height * scale;
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            // Fill white background first (JPEG doesn't support transparency)
            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);
            // Clean up object URL to prevent memory leak
            URL.revokeObjectURL(objectUrl);
            // Use JPEG at 95% quality for 4K-crisp logo
            resolve(canvas.toDataURL('image/jpeg', 0.95));
          };
          img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            resolve(null);
          };
          img.src = objectUrl;
        });
      } catch (e) {
        oqLog('Failed to fetch logo for PDF:', e);
        return null;
      }
    }

    function addEmailLink(doc, text, x, y, options = {}) {
      const emailMatch = text.match(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/);
      if (emailMatch) {
        const email = emailMatch[1];
        const textBeforeEmail = text.substring(0, text.indexOf(email));
        const textAfterEmail = text.substring(text.indexOf(email) + email.length);

        // Draw text before email (keep current color)
        if (textBeforeEmail) doc.text(textBeforeEmail, x, y, options);

        // Draw email in brand blue
        const emailStartX = x + doc.getTextWidth(textBeforeEmail);
        doc.setTextColor(0, 64, 128); // Brand blue #004080
        doc.text(email, emailStartX, y, options);
        const emailWidth = doc.getTextWidth(email);
        doc.link(emailStartX, y - 3, emailWidth, 5, { url: 'mailto:' + email });

        // Draw text after email (restore to black)
        if (textAfterEmail) {
          doc.setTextColor(0, 0, 0);
          doc.text(textAfterEmail, emailStartX + emailWidth, y, options);
        }
        doc.setTextColor(0, 0, 0); // Reset to black
      } else {
        doc.text(text, x, y, options);
      }
    }

    async function renderHeader(doc, y, quoteData, brandBlue, base64Logo) {
      y = Number(y) || DEFAULT_MARGIN_TOP;
      if (base64Logo) {
        const img = new Image();
        img.src = base64Logo;
        await new Promise((resolve, reject) => {
          img.onload = () => {
            const maxWidth = 50;
            const maxHeight = 20;
            const widthRatio = maxWidth / img.width;
            const heightRatio = maxHeight / img.height;
            const scale = Math.min(widthRatio, heightRatio);
            const displayWidth = img.width * scale;
            const displayHeight = img.height * scale;
            try {
              doc.addImage(base64Logo, 'JPEG', DEFAULT_MARGIN_LR, y, displayWidth, displayHeight);
            } catch (e) {
              oqLog('Failed to add logo image to PDF:', e);
            }
            y += displayHeight + 8;
            resolve();
          };
          img.onerror = reject;
        }).catch(e => oqLog('Logo image load error:', e));
      }
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      doc.setTextColor(brandBlue);
      doc.text(`${t.quoteTitle} ${t.unofficial}`, DEFAULT_MARGIN_LR, y);
      y += 10;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text(`${t.reference} ${quoteData.reference}`, DEFAULT_MARGIN_LR, y);
      doc.text(`${t.date} ${new Date(quoteData.timestamp).toLocaleString()}`, doc.internal.pageSize.getWidth() - DEFAULT_MARGIN_LR, y, { align: 'right' });
      y += 8;
      const maxWidth = doc.internal.pageSize.getWidth() - 2 * DEFAULT_MARGIN_LR;
      // "What happens next?" section header
      if (t.whatHappensNext) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(11);
        doc.setTextColor(brandBlue);
        doc.text(t.whatHappensNext, DEFAULT_MARGIN_LR, y);
        y += 6;
      }
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(60);
      doc.setFontSize(9);
      const noteLines = doc.splitTextToSize(t.note, maxWidth);
      doc.text(noteLines, DEFAULT_MARGIN_LR, y);
      y += noteLines.length * 4 + 6;
   
      if (quoteData.name || quoteData.company || quoteData.email || quoteData.phone || quoteData.message) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(14);
        doc.setTextColor(brandBlue);
        doc.text(t.customerInfo, DEFAULT_MARGIN_LR, y);
        y += 8;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        const midX = DEFAULT_MARGIN_LR + 100;
        if (quoteData.name || quoteData.company) {
          if (quoteData.name) doc.text(`${t.nameLabel}: ${quoteData.name}`, DEFAULT_MARGIN_LR, y);
          if (quoteData.company) doc.text(`${t.companyLabel}: ${quoteData.company}`, midX, y);
          y += 6;
        }
        if (quoteData.email || quoteData.phone) {
          if (quoteData.email) addEmailLink(doc, `${t.emailLabel}: ${quoteData.email}`, DEFAULT_MARGIN_LR, y);
          if (quoteData.phone) doc.text(`${t.phoneLabel.replace(/ \(.+\)/, '')}: ${quoteData.phone}`, midX, y);
          y += 6;
        }
        if (quoteData.message) {
          const messageLines = doc.splitTextToSize(`${t.messageLabel.replace(/ \(.+\)/, '')}: ${quoteData.message}`, maxWidth);
          doc.text(messageLines, DEFAULT_MARGIN_LR, y);
          y += messageLines.length * 5 + 6;
        }
      }
      doc.setDrawColor(brandBlue);
      doc.setLineWidth(0.4);
      const lineStartX = DEFAULT_MARGIN_LR;
      const lineEndX = doc.internal.pageSize.getWidth() - DEFAULT_MARGIN_LR;
      const lineY = Math.max(y, DEFAULT_MARGIN_TOP + 8);
      doc.line(lineStartX, lineY, lineEndX, lineY);
      y = lineY + 1;
      return y;
    }
   
    function renderTableHeader(doc, y, brandBlue) {
      y = Number(y) || DEFAULT_MARGIN_TOP;
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.setTextColor(255, 255, 255);
      doc.setFillColor(0, 64, 128);
      const col1x = DEFAULT_MARGIN_LR;
      const col2x = col1x + 74;
      const col3x = doc.internal.pageSize.getWidth() - DEFAULT_MARGIN_LR - 30;
      const headerHeight = 8;
      const rectTopAttempt = y - 5.5;
      const rectTop = Math.max(rectTopAttempt, DEFAULT_MARGIN_TOP);
      doc.rect(DEFAULT_MARGIN_LR, rectTop, doc.internal.pageSize.getWidth() - 2 * DEFAULT_MARGIN_LR, headerHeight, 'F');
      const textY = rectTop + headerHeight - 2;
      doc.text(t.tableSku, col1x + 2, textY);
      doc.text(t.tableProduct, col2x + 2, textY);
      doc.text(t.tableQty, col3x + 26, textY, { align: 'right' });
      const returnedY = rectTop + headerHeight + 6;
      return returnedY;
    }
   
    function renderFooter(doc, brandBlue) {
      const pageHeight = doc.internal.pageSize.getHeight();
      const pageWidth = doc.internal.pageSize.getWidth();
      const maxWidth = pageWidth - 2 * DEFAULT_MARGIN_LR;
      let footerY = pageHeight - 38;
      doc.setDrawColor(brandBlue);
      doc.setLineWidth(0.4);
      doc.line(DEFAULT_MARGIN_LR, footerY - 8, pageWidth - DEFAULT_MARGIN_LR, footerY - 8);
      footerY -= 2;
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(60);
      doc.text(t.footer_contact_title, DEFAULT_MARGIN_LR, footerY);
      footerY += 8;
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      // Two balanced columns: Sales and General Inquiry
      const col1 = DEFAULT_MARGIN_LR;
      const col2 = pageWidth / 2;
      doc.text(t.footer_sales, col1, footerY);
      doc.text(t.footer_inquiry, col2, footerY);
      footerY += 6;
      doc.setFont('helvetica', 'normal');
      const colA = [
        { text: `${t.footer_na} na@optic.ca`, email: 'na@optic.ca' },
        { text: `${t.footer_latam} latam@optic.ca`, email: 'latam@optic.ca' },
        { text: `${t.footer_eu} eu@optic.ca`, email: 'eu@optic.ca' }
      ];
      const colB = [
        { text: `info@optic.ca | ${t.footer_phone_na}`, email: 'info@optic.ca' },
        { text: t.footer_phone_latam, email: null }
      ];
      const maxLines = Math.max(colA.length, colB.length);
      for (let i = 0; i < maxLines; i++) {
        if (i < colA.length) addEmailLink(doc, colA[i].text, col1, footerY);
        if (i < colB.length) {
          if (colB[i].email) addEmailLink(doc, colB[i].text, col2, footerY);
          else doc.text(colB[i].text, col2, footerY);
        }
        footerY += 5.5;
      }
      footerY += 4;
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.setTextColor(46, 125, 50); // Green color
      const disclaimerLines = doc.splitTextToSize(t.footer_disclaimer, maxWidth);
      doc.text(disclaimerLines, DEFAULT_MARGIN_LR, footerY);
    }
   
    async function oqGeneratePdf(quoteData, options = {}) {
      const { returnBlob = false } = options;
      try {
        if (!window.jspdf) {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/s/files/1/0618/5559/6738/files/jspdf.umd.min.js?v=1767633227';
          document.head.appendChild(script);
          await new Promise((resolve, reject) => {
            script.onload = resolve;
            script.onerror = () => reject(new Error('Failed to load jsPDF'));
          });
        }
   
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF({ unit: 'mm', format: 'a4' });
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const brandBlue = '#004080';
        let marginTop = DEFAULT_MARGIN_TOP;
        let marginLR = DEFAULT_MARGIN_LR;
        let base64Logo = null;
   
        if (logoUrl) {
          base64Logo = await getBase64ImageFromUrl(logoUrl);
        }
   
        let y = await renderHeader(doc, marginTop, quoteData, brandBlue, base64Logo);
        y = renderTableHeader(doc, y, brandBlue);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        const rowHeightMin = 8;
        const lineHeight = 5.5;
   
        const validItems = (quoteData.items || []).filter(item => item && item.productTitle);
   
        validItems.forEach((item, idx) => {
          item.productTitle = item.productTitle || 'Unknown Product';
          item.sku = item.sku || 'N/A';
          item.quantity = Number(item.quantity) || 1;
   
          const col1x = marginLR;
          const col2x = col1x + 74;
          const col3x = pageWidth - marginLR - 30;
          const prodText = `${item.productTitle}`;
          const prodLines = doc.splitTextToSize(prodText, col2x - col1x - 4);
          const skuLines = doc.splitTextToSize(item.sku, col3x - col2x - 4);
          const linesUsed = Math.max(prodLines.length, skuLines.length, 1);
          const rowHeight = Math.max(rowHeightMin, linesUsed * lineHeight + 1);
   
          if (y + rowHeight + 2 > pageHeight - 42) {
            renderFooter(doc, brandBlue);
            doc.addPage();
            y = marginTop;
            y = renderHeader(doc, y, quoteData, brandBlue, base64Logo);
            y = renderTableHeader(doc, y, brandBlue);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
          }
   
          const bgTopAttempt = y - 5;
          const bgTop = Math.max(bgTopAttempt, DEFAULT_MARGIN_TOP);
          if (idx % 2 === 0) {
            doc.setFillColor(245, 247, 250);
            doc.rect(marginLR, bgTop, pageWidth - 2 * marginLR, rowHeight, 'F');
          }
   
          const prodY = y;
          const skuY = y;
          const qtyY = y;
          doc.setTextColor(0);
          doc.text(skuLines, col1x + 2, skuY);
          doc.text(prodLines, col2x + 2, prodY);
          doc.text(String(item.quantity), col3x + 26, qtyY, { align: 'right' });
   
          y += rowHeight + 2;
        });
   
        if (!validItems.length) {
          const emptyText = t.empty;
          const col1x = marginLR;
          const emptyLines = doc.splitTextToSize(emptyText, pageWidth - 2 * marginLR - 4);
          const linesUsed = emptyLines.length;
          const rowHeight = Math.max(rowHeightMin, linesUsed * lineHeight + 4);
          doc.setFillColor(245, 247, 250);
          const bgTopAttempt = y - 5;
          const bgTop = Math.max(bgTopAttempt, DEFAULT_MARGIN_TOP);
          doc.rect(marginLR, bgTop, pageWidth - 2 * marginLR, rowHeight, 'F');
          const emptyY = y;
          doc.text(emptyLines, col1x + 2, emptyY);
          y += rowHeight + 2;
        }
   
        const distinctProducts = validItems.length;
        const distinctSKUs = new Set(validItems.map(it => it.sku)).size;
        const totalQty = validItems.reduce((sum, it) => sum + (Number(it.quantity) || 0), 0);
   
        if (distinctProducts >= 2) {
          const col1x = marginLR;
          const col2x = col1x + 74;
          const col3x = pageWidth - marginLR - 30;
   
          const subtotalProdText = `${t.subtotal}: ${distinctProducts} ${t.differentProducts}`;
          const subtotalSkuText = `${distinctSKUs} ${t.differentSkus}`;
          const subtotalQtyText = `${totalQty} ${t.units}`;
   
          const prodLines = doc.splitTextToSize(subtotalProdText, col2x - col1x - 4);
          const skuLines = doc.splitTextToSize(subtotalSkuText, col3x - col2x - 4);
   
          const linesUsed = Math.max(prodLines.length, skuLines.length, 1);
          const rowHeight = Math.max(rowHeightMin, linesUsed * lineHeight + 1);
   
          if (y + rowHeight + 2 > pageHeight - 42) {
            renderFooter(doc, brandBlue);
            doc.addPage();
            y = marginTop;
            y = renderHeader(doc, y, quoteData, brandBlue, base64Logo);
            y = renderTableHeader(doc, y, brandBlue);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
          }
   
          const bgTop = Math.max(y - 5, DEFAULT_MARGIN_TOP);
          doc.setFillColor(245, 247, 250);
          doc.rect(marginLR, bgTop, pageWidth - 2 * marginLR, rowHeight, 'F');
   
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(0);
          doc.text(skuLines, col1x + 2, y);
          doc.text(prodLines, col2x + 2, y);
          doc.text(String(totalQty), col3x + 26, y, { align: 'right' });
   
          doc.setFont('helvetica', 'normal');
          y += rowHeight + 2;
        }
   
        renderFooter(doc, brandBlue);
        const langPrefix = lang === "fr" ? "Soumission-" : lang === "es" ? "Cotizacion-" : "Quote-";
        const filename = langPrefix + quoteData.reference + ".pdf";

        if (returnBlob) {
          // Return blob for Formspree attachment
          const blob = doc.output('blob');
          return { blob, filename };
        } else {
          // Normal download
          doc.save(filename);
          return { filename };
        }
      } catch (e) {
        console.error('PDF generation failed:', e);
        alert(t.pdfFail);
        throw e;
      }
    }
   
    function init() {
      const style = document.createElement('style');
      style.innerHTML = `
        .oq-add-to-quote { background: #004080; color: #fff; padding: 10px 16px; border-radius: 4px; border: none; cursor: pointer; }
        .oq-add-to-quote:hover { background: #003366; }
        .oq-added-message { background: #e6f7e6; color: #0a0; padding: 8px; border-radius: 5px; animation: oqFadeIn 0.3s ease-in-out; }
        .oq-added-message.fade-out { animation: oqFadeOut 0.3s ease-in-out forwards; }
        @keyframes oqFadeOut { from { opacity: 1; transform: translateY(0); } to { opacity: 0; transform: translateY(-5px); } }
        .oq-edit-item, .oq-remove-item {
          padding: 4.2px 8.4px;
          min-width: 46px;
          min-height: 25px;
          font-size: 11.5px;
          border: 1px solid #ddd;
          border-radius: 4px;
          background: #f0f0f0;
          cursor: pointer;
        }
        .oq-edit-item:hover, .oq-remove-item:hover { background: #e0e0e0; }
        .oq-remove-item { font-size: 18px; line-height: 1; padding: 2px 8px; min-width: 30px; }
       
        /* Toast Styles */
        .oq-premium-toast {
          position: fixed;
          bottom: 90px;
          right: 20px;
          background: #ffffff;
          border: 1px solid #e0e0e0;
          border-radius: 12px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.14);
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 14px;
          max-width: 320px;
          width: fit-content;
          z-index: 99999;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          animation: oqToastIn 0.32s ease-out forwards;
          pointer-events: auto;
          opacity: 0;
          transform: translateY(12px);
        }
        .oq-premium-toast.removing { animation: oqToastOut 0.35s ease-in forwards; }
        .oq-premium-toast img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 8px;
          background: #f8f8f8;
          flex-shrink: 0;
        }
        .oq-toast-content {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;
        }
        .oq-toast-title {
          font-size: 14px;
          font-weight: 600;
          color: #1a1a1a;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .oq-toast-title svg {
          width: 16px;
          height: 16px;
          stroke: #00b300;
          stroke-width: 3;
        }
        .oq-toast-product {
          font-size: 13.5px;
          font-weight: 500;
          color: #222;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .oq-toast-meta { font-size: 12.5px; color: #666; }
        .oq-view-quote-btn {
          margin-top: 6px;
          background: #004080;
          color: #fff;
          padding: 6px 11px;
          border-radius: 20px;
          font-size: 12.5px;
          font-weight: 600;
          text-decoration: none;
          align-self: flex-start;
        }
        .oq-view-quote-btn:hover { background: #003366; }
        @keyframes oqToastIn { to { opacity: 1; transform: translateY(0); } }
        @keyframes oqToastOut { to { opacity: 0; transform: translateY(12px); } }
        @media (max-width: 768px) {
          .oq-premium-toast {
            left: 20px;
            right: 20px;
            bottom: 90px;
            max-width: none;
            width: auto;
          }
        }
       
        /* Quote Preview Panel */
        .qp-header strong { white-space: nowrap; }
        .qp-stats { display: block !important; white-space: normal !important; overflow: visible !important; text-overflow: clip !important; }
        .qp-show-more {
          display: block;
          font-weight: bold;
          font-size: 1em;
          color: #004080;
          text-decoration: none;
          background: transparent;
          border: none;
          padding: 0;
        }
        .qp-header, #qp-show-more {
          flex-shrink: 0;
          padding: 12px 16px;
        }
        #qp-show-more {
          background: #f8f9fa;
          text-align: center;
          font-weight: 600;
          color: #004080;
          border-top: 1px solid #eee;
        }
        .qp-show-more:hover { text-decoration: underline; color: #003066; }
        .qp-title, .qp-meta {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-word;
          hyphens: auto;
        }
        .qp-info { flex: 1; min-width: 0; }
        .qp-items {
          overflow-y: auto;
          overflow-x: hidden;
          max-height: 70vh;
          flex: 1;
          min-height: 80px;
          padding: 0 8px;
        }
        #quote-preview-panel {
          min-width: clamp(260px, 26vw, 340px) !important;
          max-width: 340px;
          display: flex;
          flex-direction: column;
          min-height: 120px;
          max-height: 80vh;
          background: #ffffff;
          border: 1px solid #e0e0e0;
          border-radius: 16px;
          box-shadow: 0 12px 32px rgba(0,0,0,0.16);
          overflow: hidden;
          font-size: 13.5px;
        }
        .qp-header {
          padding: 14px 16px 10px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          gap: 5px;
        }
        .qp-header strong {
          font-size: 15px;
          font-weight: 700;
          white-space: normal;
          line-height: 1.3;
        }
        .qp-stats {
          font-size: 13px;
          color: #555;
          white-space: normal;
          word-break: break-word;
        }
        .qp-item {
          display: flex;
          gap: 10px;
          padding: 8px 0;
          border-bottom: 1px solid #f0f0f0;
        }
        .qp-item:last-child { border-bottom: none; }
        .qp-thumb {
          width: 44px;
          height: 44px;
          object-fit: cover;
          border-radius: 8px;
          background: #f8f8f8;
          flex-shrink: 0;
        }
        .qp-title {
          font-weight: 600;
          font-size: 13.5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .qp-meta {
          font-size: 12.5px;
          color: #666;
          margin-top: 2px;
        }
        .qp-stats-line {
          display: block;
          text-align: center;
          font-size: 12px;
          line-height: 1.25;
          opacity: 0.9;
          margin-top: 2px;
        }
        .qp-stats-line:first-child { margin-top: 0; }
        #quote-bubble {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 99999;
        }
      `;
      document.head.appendChild(style);
      function fixControls(wrapper) {
        if (wrapper.dataset.oqFixed === 'true') return;
        const addBtn = wrapper.querySelector('.oq-add-to-quote');
        const qtyInput = wrapper.querySelector('input[type="number"]');
        let qtyLabel = wrapper.querySelector('label[for^="oq-quantity-"]');
        if (!addBtn || !qtyInput) return;
        if (!qtyLabel) {
          qtyLabel = document.createElement('label');
          qtyLabel.textContent = 'Quantity:';
          qtyLabel.setAttribute('for', qtyInput.id);
        }
        qtyLabel.classList.add('oq-quantity-label');
        let qtyWrapper = document.createElement('div');
        qtyWrapper.className = 'oq-quantity-wrapper';
        qtyWrapper.appendChild(qtyLabel);
        qtyWrapper.appendChild(qtyInput);
        let controlsRow = document.createElement('div');
        controlsRow.className = 'oq-controls-row';
        controlsRow.appendChild(addBtn);
        controlsRow.appendChild(qtyWrapper);
        wrapper.innerHTML = '';
        wrapper.appendChild(controlsRow);
        wrapper.dataset.oqFixed = 'true';
      }
     
      const observer = new MutationObserver(() => {
        try {
          observer.disconnect();
          document.querySelectorAll('.oq-quote-builder').forEach(fixControls);
          bindAddToQuoteButtons();
        } catch (err) {
          console.warn('Quote observer callback error', err);
        } finally {
          setTimeout(() => {
            try {
              observer.observe(document.body, { childList: true, subtree: true });
            } catch (e) {
              console.warn('Failed to re-observe quote DOM', e);
            }
          }, 0);
        }
      });
     
      document.querySelectorAll('.oq-quote-builder').forEach(fixControls);
      bindAddToQuoteButtons();
      bindActions();
      oqUpdateQuoteTable();
     
      observer.observe(document.body, { childList: true, subtree: true });
    }
   
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
   
    function shouldShowPreview() {
      return !location.pathname.includes('/pages/quote');
    }
   
    function initQuoteBubble() {
      document.querySelectorAll('#quote-bubble').forEach(el => el.remove());
      const div = document.createElement('div');
      div.innerHTML = QUOTE_BUBBLE_HTML;
      document.body.appendChild(div.firstElementChild);
      const btn = document.getElementById('quote-bubble-btn');
      const panel = document.getElementById('quote-preview-panel');
      btn.addEventListener('click', () => {
        if (window.innerWidth <= 768 || !shouldShowPreview()) {
          const prefix = location.pathname.startsWith('/fr') ? '/fr' : location.pathname.startsWith('/es') ? '/es' : '';
          location.href = prefix + '/pages/quote';
        }
      });
      let timeout;
      btn.parentNode.addEventListener('mouseenter', () => {
        if (!shouldShowPreview()) return;
        clearTimeout(timeout);
        panel.classList.add('visible');
      });
      btn.parentNode.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => panel.classList.remove('visible'), 200);
      });
     
      updateQuoteBubblePreview(oqQuoteBuilder);
    }
   
    const QUOTE_BUBBLE_HTML = `
      <div id="quote-bubble" class="oq-floating-bubble-wrapper">
        <button id="quote-bubble-btn" class="oq-floating-bubble" aria-label="Open Quote">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 19h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z"></path>
            <path d="M12 9v4"></path>
            <path d="M12 17h.01"></path>
          </svg>
          <span id="quote-badge" class="oq-bubble-count">0</span>
        </button>
        <div id="quote-preview-panel" class="oq-bubble-preview">
          <div class="qp-header">
            <strong>Quote Builder Preview</strong>
            <div class="qp-stats"></div>
          </div>
          <div id="qp-items" class="qp-items"></div>
          <a id="qp-show-more" class="qp-show-more" href="/pages/quote">Go to Quote</a>
        </div>
      </div>
    `;
   
    function updateQuoteBubblePreview(items = []) {
      const badge = document.getElementById('quote-badge');
      const statsEl = document.querySelector('.qp-stats');
      const itemsEl = document.getElementById('qp-items');
      const panel = document.getElementById('quote-preview-panel');
     
      if (!badge || !panel || !statsEl || !itemsEl) return;
     
      const totalUnits = items.reduce((sum, i) => sum + (Number(i.quantity) || 0), 0);
      badge.textContent = totalUnits;
     
      if (window.location.pathname.includes('/pages/quote')) {
        panel.classList.remove('visible');
        return;
      }
     
      if (!items.length) {
        statsEl.textContent = '0 products · 0 units';
        itemsEl.innerHTML = '<div style="text-align:center;color:#999;padding:20px 0">No items yet</div>';
        return;
      }
     
      const sortedItems = [...items].reverse();
      const uniqueProducts = sortedItems.length;
      const totalQty = sortedItems.reduce((sum, i) => sum + (Number(i.quantity) || 0), 0);
     
      function localizeCount(template, count) {
        return template.replace('{count}', (Number(count) || 0).toLocaleString());
      }
     
      statsEl.innerHTML =
        `<span class="qp-stats-line">${localizeCount(t.differentProductsLabel, uniqueProducts)}</span>` +
        `<span class="qp-stats-line">${localizeCount(t.totalProductQuantityLabel, totalQty)}</span>`;
     
      const tempEl = document.createElement('div');
      tempEl.style.whiteSpace = 'nowrap';
      tempEl.style.position = 'absolute';
      tempEl.style.visibility = 'hidden';
      tempEl.textContent = 'Quote Builder Preview ' + statsEl.textContent;
      document.body.appendChild(tempEl);
      const minW = tempEl.offsetWidth + 32;
      document.body.removeChild(tempEl);
      panel.style.minWidth = `${minW}px`;
     
      itemsEl.innerHTML = sortedItems.map(item => {
        const thumb = (item.thumbnail?.trim() && item.thumbnail !== '')
                      ? item.thumbnail
                      : 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSIjZjBmMGYwIi8+PC9zdmc+';
        const title = item.productTitle || 'Product';
        const variant = item.variantName && item.variantName !== 'N/A' ? item.variantName : '';
        return `
        <div class="qp-item">
          <img class="qp-thumb" src="${thumb}" alt="${title}" loading="lazy" onerror="this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiBmaWxsPSIjZjBmMGYwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTIiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiNjY2NjY2MiPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg=='; this.style.background='#f0f0f0';">
          <div class="qp-info">
            <div class="qp-title">${escapeHtml(title)}</div>
            <div class="qp-meta">
              × ${item.quantity}${variant ? ` | ${escapeHtml(variant)}` : ''}
            </div>
          </div>
        </div>
      `;
      }).join('');
     
      panel.classList.remove('expanded');
      const showMoreBtn = document.getElementById('qp-show-more');
      if (showMoreBtn) showMoreBtn.textContent = 'Go to Quote';
    }
   
    document.addEventListener('DOMContentLoaded', function() {
      if (typeof initQuoteBubble === 'function') {
        initQuoteBubble();
      }
    });
})();